import * as React from "react";
import { Box, Paper, Stack, TextField, Typography, Button, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { adminFetch } from "../services/adminFetch";

export default function LoginPage() {
    const nav = useNavigate();
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [err, setErr] = React.useState<string | null>(null);
    const [loading, setLoading] = React.useState(false);

    const submit = async () => {
        setErr(null);
        setLoading(true);
        try {
            const res = await adminFetch("/api/admin/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });
            if (!res.ok) {
                const d = await res.json().catch(() => ({}));
                setErr(d?.error || "Login failed");
                return;
            }
            nav("/dashboard");
        } catch {
            setErr("Network error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
            <Paper variant="outlined" sx={{ width: "100%", maxWidth: 420, borderRadius: 3, p: 3 }}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 1000 }}>RentBoard</Typography>
                        <Typography variant="body2" color="text.secondary">Admin login</Typography>
                    </Box>

                    {err ? <Alert severity="error">{err}</Alert> : null}

                    <TextField label="Email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
                    <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth />

                    <Button variant="contained" onClick={submit} disabled={loading} sx={{ py: 1.1 }}>
                        {loading ? "Signing in..." : "Sign in"}
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
}
